import { PROJECT_PHASE_ID } from "constants/index";

const PRECONSTRUCTION_PHASE_LABEL = "Preconstruction";

type ProjectPhaseDetails = {
  project_phase?: { id: number; value: string } | null;
};

type ProjectPhaseSource = {
  phase?: number | null;
  project_phase?: string | { id?: number | null; value?: string | null } | null;
};

export function isPreconstructionPhase(
  project: ProjectPhaseSource | null | undefined
): boolean {
  if (!project) {
    return false;
  }

  if (project.phase === PROJECT_PHASE_ID.PRECONSTRUCTION) {
    return true;
  }

  const projectPhase = project.project_phase;
  if (typeof projectPhase === "string") {
    return projectPhase === PRECONSTRUCTION_PHASE_LABEL;
  }

  return projectPhase?.id === PROJECT_PHASE_ID.PRECONSTRUCTION;
}

export function isPreconstructionProjectHome(
  projectDetails: ProjectPhaseDetails | undefined,
  buyoutEnabled: boolean,
  canViewDesignPage: boolean
): boolean {
  return (
    buyoutEnabled &&
    canViewDesignPage &&
    projectDetails?.project_phase?.id === PROJECT_PHASE_ID.PRECONSTRUCTION
  );
}

export function getProjectHomePath(
  projectId: string,
  openDesignPackages: boolean
): string {
  return openDesignPackages
    ? `/project/${projectId}/design-packages`
    : `/project/${projectId}/dashboard`;
}

const DASHBOARD_VIEW_PARAM = "view";
const DASHBOARD_VIEW_VALUE = "dashboard";

/**
 * Dashboard URL that opts out of the Preconstruction home redirect, so
 * precon-phase projects can still open the Project Dashboard on purpose.
 */
export function getProjectDashboardPath(projectId: string): string {
  return `/project/${projectId}/dashboard?${DASHBOARD_VIEW_PARAM}=${DASHBOARD_VIEW_VALUE}`;
}

export function isExplicitProjectDashboardView(search: string): boolean {
  return (
    new URLSearchParams(search).get(DASHBOARD_VIEW_PARAM) ===
    DASHBOARD_VIEW_VALUE
  );
}
